'use client';

import { c as _c } from "react/compiler-runtime";
import './stepper-tabbed.scss';
import * as Tabs from '@radix-ui/react-tabs';
import { parseAsInteger, useQueryState } from 'nuqs';
import { useTranslation } from 'react-i18next';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { trackClick } from '@sola/tracking/components/datalayer.tsx';
import { SegmentedStepper } from '../../atoms/segmented-stepper/segmented-stepper.tsx';
import { cn } from '../../utils/helpers.ts';
import { StepperCompact } from '../stepper-compact/stepper-compact.tsx';
export type StepperTabbedProps = {
  title?: string;
  items?: Array<FlexibleContentProps>;
  /** When set, tabs beyond this index cannot be clicked. */
  maxStep?: number;
};
export const StepperTabbed: React.FC<StepperTabbedProps> = t0 => {
  const $ = _c(8);
  const {
    title,
    items,
    maxStep
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsInteger.withDefault(0);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [activeIndex, setActiveIndex] = useQueryState("step", t1);
  const {
    t
  } = useTranslation("help-me");
  let t2;
  if ($[1] !== activeIndex || $[2] !== items || $[3] !== maxStep || $[4] !== setActiveIndex || $[5] !== t || $[6] !== title) {
    t2 = items && items.length > 0 && <Tabs.Root className="StepperTabbed" defaultValue="0" value={activeIndex.toString()} onValueChange={e => {
      const next = Number(e);
      if (maxStep !== undefined && next > maxStep) {
        return;
      }
      setActiveIndex(next);
    }}><div className="md:hidden"><StepperCompact items={items} /></div><Tabs.List className="StepperTabbed__list hidden md:flex justify-between mx-auto" aria-label={title || t("skippy:StepperTabbed.defaultAriaLabel")}>{items.map((item, index) => <Tabs.Trigger className="flex flex-1 justify-center align-center mx-auto gap-snug-xl px-comfy-md py-comfy-xs label-potent label-lg" value={index.toString()} key={item.title} disabled={maxStep !== undefined && index > maxStep} onClick={() => {
          if (maxStep !== undefined && index > maxStep) {
            return;
          }
          setActiveIndex(index);
          trackClick(`${index + 1}. ${item.title}`, undefined, "Stepper__desktop");
        }}><span className="hidden md:flex">{activeIndex > index && <span className="flex align-center px-snug-xl"><ArkIcon iconName="check-circle" className="StepperTabbed__icon" /></span>}<span className={cn("label-potent label-lg", {
              "StepperTabbed__button--active": activeIndex >= index
            })}>{activeIndex <= index ? `${index + 1}. ${item.title}` : item.title}</span></span></Tabs.Trigger>)}</Tabs.List><SegmentedStepper count={items.length} activeItem={activeIndex} className="StepperTabbed__stepper" /><div className="StepperTabbed__divider" />{items.map(_temp)}</Tabs.Root>;
    $[1] = activeIndex;
    $[2] = items;
    $[3] = maxStep;
    $[4] = setActiveIndex;
    $[5] = t;
    $[6] = title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
function _temp(item_0, index_0) {
  return <Tabs.Content className="StepperTabbed__content pt-comfy-lg @lg:pt-comfy-xl align-center justify-around m-auto" value={index_0.toString()} key={item_0.title}>{item_0.body}</Tabs.Content>;
}